export const UPDATE_SYSTEM_DEFAULT_APPS = 'UPDATE_SYSTEM_DEFAULT_APPS';
export const UPDATE_RUBIX_SERVICE_VERSION = 'UPDATE_RUBIX_SERVICE_VERSION';
